export default "__VITE_ASSET__CI07bAEj__";